import React from "react";
import { Box } from "@mui/material";

import { ProjectsHighlights } from "../components/projectsHighlights/ProjectsHighlights";

export const Interior: React.FC = () => {
  return (
    <Box sx={{ overflow: "hidden" }}>
      <ProjectsHighlights
        projectCategoryFilters={["INTERIOR"]}
        disableProjectRandomization={true}
      />
    </Box>
  );
};
